// #region Dependencias
import { combineReducers } from 'redux'
import auth from 'store/slices/authSlice'
import pages from 'store/slices/pagesSlice'
import analytics from 'store/slices/analyticsSlice'
import ui from 'store/slices/uiSlice'
// #endregion

/**
 * Reducer principal de la aplicación, que combina todos los demás reducers.
 */
const rootReducer = combineReducers({
  auth,
  pages,
  analytics,
  ui
})

export default rootReducer
